<template>
  <generic-modal
    size
    :title="$t('customer')"
    icon="user tie"
    image="/images/icons/customer-1.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <generic-container
        v-bind:searchable="false"
        v-bind:show_plus="false"
        icon="info circle"
        :title="$t('general information')"
      >
        <div class="ui form" ref="form">
          <div class="field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="name" />
          </div>
          <div class="field" v-for="(attribute, index) in attributes" v-bind:key="index">
            <label for>{{ attribute.display_name }}</label>
            <input
              type="text"
              v-model="attributes[index].value"
              :name="attribute.field_name"
              v-if="['text', 'email'].includes(attribute.type)"
            />
            <div
              class="ui calendar"
              ref="calendar"
              v-if="['date'].includes(attribute.type)"
              :data-index="index"
            >
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="text" placeholder="Date/Time" v-model="attributes[index].value" />
              </div>
            </div>
          </div>
          <div class="ui error message"></div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";

export default {
  components: {
    "generic-modal": GenericModal,
    "generic-container": GenericContainer
  },
  computed: {},
  props: { customer: Object },
  data() {
    return {
      attributes: [],
      name: ""
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/customer/do-save", {
            i: vm.customer ? vm.customer.uuid : undefined,
            n: vm.name,
            s: {
              attributes: vm.attributes.map(attr => {
                return { name: attr.display_name, value: attr.value };
              })
            }
          })
            .then(customer => {
              vm.$emit("succedded", customer);
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    }
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/customer/do-get-configuration")
      .then(conf => {
        if (conf && conf.setup && conf.setup.attributes) {
          if (vm.customer && vm.customer.customer_id) {
            vm.name = vm.customer.name;
          }

          vm.attributes = conf.setup.attributes.map(att => {
            let val = "";
            if (vm.customer && vm.customer.customer_id) {
              let trgtAttr = vm.customer.setup.attributes.find(
                n => n.name == att.name
              );
              if (trgtAttr) val = trgtAttr.value;
            }
            return {
              id: att.id,
              type: att.type,
              display_name: att.name,
              field_name: att.name.toLowerCase().replace(" ", "_"),
              value: val
            };
          });

          window.jQuery(vm.$refs.form).form({
            fields: { name: ["empty"] }
          });
        }
      })
      .catch(err => {
        toast(this.$el, "error", err);
      });
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {
      let vm = this;
      window.jQuery(vm.$refs.calendar).calendar({
        type: "date",
        onChange(date) {
          let index = window.jQuery(this).data("index");
          if (index >= 0) vm.attributes[index].value = date;
        }
      });
    });
  }
};
</script>
